import React, { useContext, useState } from "react";
import LanguageContext from "../../../utils/Contexts/LanguageContext";
import ThemeContext from "../../../utils/Contexts/ThemeContext";
import Constant from "../../Constants";
import UserContext from "../../../utils/Contexts/UserContext";
import axiosInstance from "../../../utils/Requests/axios";
import toast from "react-hot-toast";

function EmailSection({ email }) {
  const { t } = useContext(LanguageContext);
  const { selectedTheme } = useContext(ThemeContext);
  const { themeStatus } = Constant();
  const { userData } = useContext(UserContext);
  const [newEmail, setNewEmail] = useState("");

  const handleSaveChanges = () => {
    if (!userData?.uuid) return;
    const payload = {
      email: newEmail,
    };
    axiosInstance
      .put(`settings/users/${userData.uuid}/profile/email`, payload)
      .then(() => {
        toast.success(t("An email has been sent to you!"));
      })
      .catch((error) => {
        toast.error(t("Error updating email"));
      });
  };

  return (
    <div
      id="EmailSection"
      className={`card cardSetting ${themeStatus?.[selectedTheme]}`}
    >
      <div className="card-header">
        <h4
          className="card-title responsive-title"
          style={{ fontWeight: "700" }}
        >
          {t("Email")}
        </h4>
      </div>

      <div className="card-body">
        <label
          className="form-check-label responsive-text"
          style={{ color: "var(--text-email)" }}
        >
          {t("Your current email address is")}{" "}
          <span style={{ color: "#377dff" }}>{email}</span>
        </label>

        <div className="d-flex account-setting-responsiveness w-100 mt-3">
          <label
            className="form-label card-text"
            style={{ color: "var(--whiteToBlack)" }}
          >
            {t("New Email Address")}
          </label>
          <div className="profile-visibility-select">
            <input
              type="text"
              className="form-control rounded-2 account-placeholder"
              placeholder={t("Enter new email address")}
              value={newEmail}
              onChange={(e) => setNewEmail(e.target.value)}
            />
          </div>
        </div>
      </div>
      <div className="card-header p-0"></div>
      <div className="d-flex justify-content-end card-body pt-3">
        <button
          className="btn btn-primary edit-profile-btn p-0"
          onClick={handleSaveChanges}
          disabled={!newEmail}
        >
          {t("Save Changes")}
        </button>
      </div>
    </div>
  );
}

export default EmailSection;
